// TODO: нужно перенести в shared/constants
export const patterns = {
  allRoomsArea: /^\s*\d+([\.,]\d+)?(\s*[\+-]\s*\d+([\.,]\d+)?)*\s*$/,
  columnGrid: /^\d+[xх]\d+$/i,
  registrationName: /^[A-zА-яёЁ]+$/,
  numbers: /^\d+$/,
  time: /^(\d+):(\d+)$/,
  coworkingName: /^([A-zА-яёЁ0-9-](\s)*)+$/,
};
